"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Check } from "lucide-react";
export default function NazeBetonamuNanoka() {
  const benefit1 = useRevealOnScroll({
    threshold: 0.3
  });
  const benefit2 = useRevealOnScroll({
    threshold: 0.3
  });
  const benefit3 = useRevealOnScroll({
    threshold: 0.3
  });
  const benefit4 = useRevealOnScroll({
    threshold: 0.3
  });
  const benefits = [{
    title: "急成長する市場",
    description: "ベトナムは東南アジアで最も成長著しい経済圏の一つです。若く活気に満ちた労働力と安定した政治環境により、投資先として魅力的な国となっています。",
    ref: benefit1.ref,
    isVisible: benefit1.isVisible
  }, {
    title: "戦略的な地理的位置",
    description: "ベトナムはASEAN地域の中心に位置し、中国、日本、韓国などの主要市場へのアクセスが容易です。製造・物流拠点として最適な立地条件を備えています。",
    ref: benefit2.ref,
    isVisible: benefit2.isVisible
  }, {
    title: "親日的なビジネス環境",
    description: "ベトナムは日本企業に対して非常に友好的で、多くの優遇措置や支援プログラムが用意されています。日本の技術とノウハウは高く評価されています。",
    ref: benefit3.ref,
    isVisible: benefit3.isVisible
  }, {
    title: "コスト競争力",
    description: "人件費や不動産コストが他のアジア諸国と比較して低く抑えられており、製造業やサービス業の進出に適したコスト構造を実現できます。",
    ref: benefit4.ref,
    isVisible: benefit4.isVisible
  }];
  return <section className="relative min-h-screen bg-background">
      <div className="grid lg:grid-cols-2 min-h-screen">
        {}
        <div className="relative lg:sticky lg:top-0 h-[50vh] lg:h-screen overflow-hidden">
          <div className="absolute inset-0 bg-cover bg-center transition-transform duration-700 ease-out" style={{
          backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1411237/img/vietnam_cityscape_skyline.png)",
          transform: "scale(1.05)"
        }}>
            <div className="absolute inset-0 bg-primary-dark/40"></div>
          </div>
          <div className="absolute inset-0 flex items-center justify-center p-8">
            <h2 className="font-display text-4xl lg:text-5xl xl:text-6xl font-bold text-white text-center leading-tight">
              なぜベトナム<br />なのか？
            </h2>
          </div>
        </div>

        {}
        <div className="bg-light-background py-16 lg:py-24 px-6 sm:px-12 lg:px-16 xl:px-24">
          <div className="max-w-2xl mx-auto space-y-12">
            <div className="mb-16">
              <p className="text-lg text-muted-foreground leading-relaxed">
                ベトナムは、日本企業にとって最も魅力的な投資先の一つです。
                経済成長、戦略的立地、親日的な環境が揃っており、
                ビジネスの成功を後押しします。
              </p>
            </div>

            <div className="space-y-10">
              {benefits.map((benefit, i) => <div key={i} data-index={i} ref={benefit.ref} className={`flex gap-4 transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${benefit.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
              transitionDelay: benefit.isVisible ? `${i * 100}ms` : "0ms"
            }}>
                  <div className="flex-shrink-0 mt-1">
                    <div className="w-6 h-6 rounded-full bg-accent flex items-center justify-center">
                      <Check className="w-4 h-4 text-foreground-accent" strokeWidth={3} />
                    </div>
                  </div>
                  <div className="space-y-2">
                    <h3 className="font-display text-xl font-semibold text-foreground">
                      {benefit.title}
                    </h3>
                    <p className="text-muted-foreground leading-relaxed">
                      {benefit.description}
                    </p>
                  </div>
                </div>)}
            </div>

            <div className="pt-12 border-t border-border">
              <p className="text-sm text-muted-foreground italic">
                Nhật Minh Khang & Partnersは、ベトナム市場進出のあらゆる段階で
                お客様をサポートいたします。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}